import React from "react";
import {afiService} from "../../jwt/_services/hotel/afiService";

export const afiProvider = {
    getOptions
}

async function getOptions(customFilter) {
    try {
        const listItems = await afiService.getOptions( customFilter );

        return listItems.map((item) => {
            return (
                {
                    id: item?.id,
                    value: item?.code,
                    label: <label>{ item?.name }</label>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}